import { Box, Button, InputAdornment, Skeleton, Typography } from "@mui/material";
import { TextField } from "app/components/TextField";
import { PasswordIcon } from "app/icons";
import React from "react";
import { useTranslation } from "react-i18next";

import { useStyles } from "../styles";

const ProfileSkeleton = () => {
  const styles = useStyles();
  const { t, i18n } = useTranslation();

  return (
    <Box className={styles.profileCard} dir={i18n.dir()}>
      <Box className={styles.avatarSection}>
        <Typography className={styles.fieldLabel}>
          {t("PROFILE.AVATAR")}
        </Typography>
        <Skeleton variant="circular" width={82} height={82} />
      </Box>

      <Box className={styles.formField}>
        <Typography className={styles.fieldLabel}>
          {t("PROFILE.FULL_NAME")}
        </Typography>
        <Skeleton variant="rectangular" width="100%" height={48} />
      </Box>

      <Box className={styles.formField}>
        <Typography className={styles.fieldLabel}>
          {t("PROFILE.EMAIL")}
        </Typography>
        <Skeleton variant="rectangular" width="100%" height={48} />
      </Box>

      <Box className={styles.formField}>
        <Typography className={styles.fieldLabel}>
          {t("PROFILE.PHONE_NUMBER")}
        </Typography>
        <Skeleton variant="rectangular" width="100%" height={48} />
      </Box>

      <Box className={styles.passwordSection}>
        <Box className={styles.passwordRow}>
          <Button variant="outlined" className={styles.changePasswordButton}>
            {t("PROFILE.CHANGE_PASSWORD")}
          </Button>
          <Box className={styles.passwordFieldWrapper}>
            <Typography className={styles.fieldLabel}>
              {t("AUTH.PASSWORD")}
            </Typography>
            <TextField
              value={t("PROFILE.MOCK.MASKED_PASSWORD")}
              type="password"
              className={styles.textField}
              InputProps={{
                readOnly: true,
                startAdornment: (
                  <InputAdornment position="start">
                    <PasswordIcon className={styles.fieldIcon} />
                  </InputAdornment>
                ),
              }}
            />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default ProfileSkeleton;
